import styled from 'styled-components'

export const Style = styled.div`
  max-height: 70vh;

  .mapboxgl-ctrl-bottom-right {
    display: none;
  }
`
